/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    last_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    grade?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_active?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    password?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    role_ids?: Array<number> | null;
}

/**
 * Check if a given object implements the UserUpdate interface.
 */
export function instanceOfUserUpdate(value: object): value is UserUpdate {
    return true;
}

export function UserUpdateFromJSON(json: any): UserUpdate {
    return UserUpdateFromJSONTyped(json, false);
}

export function UserUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'grade': json['grade'] == null ? undefined : json['grade'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'password': json['password'] == null ? undefined : json['password'],
        'role_ids': json['role_ids'] == null ? undefined : json['role_ids'],
    };
}

export function UserUpdateToJSON(json: any): UserUpdate {
    return UserUpdateToJSONTyped(json, false);
}

export function UserUpdateToJSONTyped(value?: UserUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'phone': value['phone'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'grade': value['grade'],
        'is_active': value['is_active'],
        'password': value['password'],
        'role_ids': value['role_ids'],
    };
}

